import { isObject } from './case';

// eslint-disable-next-line import/prefer-default-export
export function cleanEmptyFields(item) {
  if (
    (!item && item !== 0 && item !== false) ||
    JSON.stringify(item) === '[]' ||
    JSON.stringify(item) === '{}'
  )
    return null;

  if (Array.isArray(item))
    return item.map(value => cleanEmptyFields(value)).filter(value => value !== null);

  if (isObject(item))
    return Object.entries(item)
      .map(([key, value]) => [key, cleanEmptyFields(value)])
      .filter(([, value]) => value !== null)
      .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {});

  return item;
}

/**
 *  UTILS TO REMOVE AFTER FASTAPI MIGRATION
 */

export function handleApiError(error, defaultMessage = 'Something went wrong') {
  if (!error.response) {
    console.error('Error', error);
    return {
      error: true,
      message: `${error.message}, please contact your webmaster` || 'An error occured',
    };
  }

  console.error('Error Response', error.response);

  if (!error.response.data) {
    return {
      error: true,
      status: error.response.status,
      message: defaultMessage,
    };
  }

  if (!error.response.data.message) {
    return {
      error: true,
      status: error.response.status,
      htmlMessage: error.response.data,
    };
  }

  return {
    error: true,
    status: error.response.status,
    message: error.response.data.message,
  };
}

export function parseArrayParamsToQueryStrings(paramsObj = {}) {
  return Object.entries(paramsObj).reduce((acc, [key, val]) => {
    if (Array.isArray(val)) {
      return { ...acc, [key]: val.join(',') };
    }
    return { ...acc, [key]: val };
  }, {});
}
